<template>
    <span>{{ validStr }}</span>
</template>

<script>
export default {
    name: "account_valid",
    props: ["valid"],
    computed: {
        validStr: function () {
            return this.valid ? "有効" : "無効";
        },
    },
};
</script>